export function SponsorBanner() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8" data-testid="sponsor-banner">
      {/* Amazon Box */}
      <a href="https://amzn.to/41436bl" target="_blank" rel="noopener noreferrer" className="block border border-[#E8E2D9] p-5 hover:border-[#C5A028] hover:shadow-md transition-all group" data-testid="amazon-sponsor" style={{background: 'linear-gradient(135deg, #FFFBF0 0%, #FFF5E0 50%, #FFFAF2 100%)'}}>
        <p className="text-xs font-semibold tracking-widest uppercase text-[#C5A028] mb-2">Sponsored Partner</p>
        <p className="font-semibold text-[#1C1917] text-sm group-hover:text-[#C5A028] transition-colors mb-1">Shop Fashion on Amazon</p>
        <p className="text-xs text-[#78716C] mb-3">Found your size? Shop 50+ brands with free returns.</p>
        <p className="text-lg mb-2 tracking-wider">👗 👚 👖 👠 👢 👜</p>
        <span className="inline-flex items-center gap-1.5 bg-[#FF9900] text-white px-3 py-1 text-xs font-bold rounded-sm group-hover:bg-[#E88B00] transition-colors">Shop Now</span>
        <p className="text-[10px] text-[#78716C] mt-2 italic">Ad: As an Amazon Associate, TrueFitGuide earns from qualifying purchases. This is a paid affiliate link.</p>
      </a>
      {/* ToneHealing Sponsor Box */}
      <a href="https://tonehealing.com" target="_blank" rel="noopener noreferrer" className="block overflow-hidden border border-[#E8E2D9] hover:border-[#9B7FD4] hover:shadow-md transition-all group" data-testid="tonehealing-sponsor" style={{background: 'linear-gradient(135deg, #F5F0FF 0%, #EDE4FF 50%, #F9F5FF 100%)'}}>
        <div className="flex items-center gap-3 p-5">
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold tracking-widest uppercase text-[#7C5CBF] mb-2">Sponsored</p>
            <p className="font-semibold text-[#1C1917] text-sm leading-tight mb-1">Support Your Mind & Body with <span className="text-[#7C5CBF]">Sound Frequencies</span></p>
            <p className="text-xs text-[#78716C] mb-2">Fall asleep in minutes. Melt anxiety away. Sharpen your focus naturally. Free sound therapy — just press play.</p>
            <div className="flex flex-wrap gap-1.5 mb-3">
              <span className="text-[10px] bg-white/80 text-[#78716C] px-1.5 py-0.5 border border-[#E8E2D9] rounded-full">🌙 Sleep</span>
              <span className="text-[10px] bg-white/80 text-[#78716C] px-1.5 py-0.5 border border-[#E8E2D9] rounded-full">🧘 Calm</span>
              <span className="text-[10px] bg-white/80 text-[#78716C] px-1.5 py-0.5 border border-[#E8E2D9] rounded-full">🎯 Focus</span>
              <span className="text-[10px] bg-white/80 text-[#78716C] px-1.5 py-0.5 border border-[#E8E2D9] rounded-full">💆 Pain Relief</span>
            </div>
            <span className="inline-flex items-center gap-1.5 bg-[#7C5CBF] text-white px-3 py-1 text-xs font-bold rounded-sm group-hover:bg-[#6B4FA8] transition-colors">Click Here</span>
          </div>
          <div className="flex-shrink-0 hidden sm:block">
            <img src="https://static.prod-images.emergentagent.com/jobs/e586dc18-7e49-4762-9a32-fdcca74463b6/images/4934b7f9e8db17a37a56475081896b2c65939f6c0ba1eb7b6972c30393fe8a80.png" alt="Sound therapy meditation" className="w-20 h-20 rounded-full object-cover" />
          </div>
        </div>
        <div className="px-5 pb-2">
          <p className="text-[10px] text-[#9B8FC4] italic">Ad: This is a sponsored link to an affiliated website. You will leave TrueFitGuide.com.</p>
        </div>
      </a>
    </div>
  );
}

export function ClickBankBanner() { return null; }

export function AdSensePlaceholder() {
  return (
    <div className="border border-dashed border-[#E8E2D9] p-6 text-center mt-4" data-testid="adsense-placeholder">
      <p className="text-xs text-[#78716C]">Advertisement</p>
      <p className="text-xs text-[#78716C] mt-1">Google AdSense - Pending approval</p>
    </div>
  );
}

export function AdvertiseHere() { return null; }
